import { call, put, takeLatest, select } from 'redux-saga/effects'
import { handleApiErrors } from '../../lib/api-errors'
import axiosApi from '../../views/client/axiosClient'

import * as Constants from './constants'
import * as brActions from './actions'
const getNganhHangState = state => state.nganhHang;

function handleRequest (request) {
  return request
    .then(handleApiErrors)
    .then( function(response){
      return response.data;
    })
    .then(json => json)
    .catch((error) => { throw error })
}

function listRequestApi (formData) {
  const request = axiosApi().post(
    Constants.NGANHHANG_LIST_API, 
    formData
  )

  return handleRequest(request);
}

function detailRequestApi (formData) {
  const request = axiosApi().post(
    Constants.NGANHHANG_DETAIL_API, 
    formData
  )

  return handleRequest(request);
}

function nganhHangUpdateRequestApi (formData) {
  const request = axiosApi().post(
    Constants.NGANHHANG_UPDATE_API, 
    formData
  )

  return handleRequest(request);
}

function* nganhHangListRequestFlow () {
  const nganhHang = yield select(getNganhHangState);
  try {
    // grab the client from our action
    const results = yield call(listRequestApi, nganhHang.formData)

    // dispatch the action with our widgets!
    yield put(brActions.nganhHangListSuccess(results.data))

  } catch (error) {
    yield put(brActions.nganhHangListError(error))
  }
}

function* nganhHangDetailRequestFlow () {
  const nganhHang = yield select(getNganhHangState);
  try {
    // grab the client from our action
    const results = yield call(detailRequestApi, nganhHang.formData)

    // dispatch the action with our widgets!
    yield put(brActions.nganhHangDetailSuccess(results.data))

  } catch (error) {
    yield put(brActions.nganhHangDetailError(error))
  }
}

function* nganhHangUpdateRequestFlow (action) {
  const nganhHang = yield select(getNganhHangState);
  try {
    // grab the client from our action
    const result = yield call(nganhHangUpdateRequestApi, nganhHang.formData)

    // dispatch the action with our widgets!
    yield put(brActions.nganhHangUpdateSuccess(result));
  } catch (error) {
    yield put(brActions.nganhHangUpdateError(error))
  }
}

function* nganhHangWatcher () {
  yield [
    takeLatest(Constants.NGANHHANG_LIST_REQUESTING, nganhHangListRequestFlow),
    takeLatest(Constants.NGANHHANG_DETAIL_REQUESTING, nganhHangDetailRequestFlow),
    takeLatest(Constants.NGANHHANG_UPDATE_REQUESTING, nganhHangUpdateRequestFlow),
  ]
}

export default nganhHangWatcher



// WEBPACK FOOTER //
// ./src/views/NganhHang/sagas.js